import React from 'react'

export default class SubscriptionPlan extends React.Component {

  renderLink(text){
    if(text.includes('<a') || text.includes('href=')){
      return <div className='plan-feature'><div dangerouslySetInnerHTML={{__html: text}} /></div>
    }else{
      return <div className='plan-feature'>{text}</div>
    }
  }

  render(){
    const { title, amount, subtitle, features, planClass, buttonClass, linedAmount, action, buttonText, activePeriod, highlighted, highlightedText } = this.props
    return (
      <div style={{ position: 'relative' }} className={`subscription-plan ${planClass ? planClass : ''}`}>
        {
          highlighted && highlightedText ? (
            <div className='subscription-plan_highlighted' style={{ top: '-15px', left: '51.5px', borderRadius: '4px', fontWeight: 600, letterSpacing: '0.08em', background: '#f73767', padding: '3px 12px', position: 'absolute' }}>
              <span style={{ color: 'white', fontSize: '11px', textTransform: 'uppercase' }}>{highlightedText}</span>
            </div>
          )
          :
          undefined
        }
        <div className='plan-header'>
          <h5>{title}</h5>
          {
            linedAmount && activePeriod && activePeriod === 'year' ? (
              <h2 style={{ display: 'flex', flexDirection: 'column', fontSize: '1rem' }}>
                <span style={{ color: '#3766f6', textDecoration: 'line-through' }} dangerouslySetInnerHTML={{__html: linedAmount}}></span>
                <span style={{ color: '#f73767' }} dangerouslySetInnerHTML={{__html: amount}}></span>
              </h2>
            )
            :
            <h2>{title.toLowerCase() === 'starter' ? amount : <span dangerouslySetInnerHTML={{__html: amount}}></span>}</h2>            
          }
          <p>{subtitle}</p>
        </div>
        <div className='plan-body'>
          {
            features.map((feature, idx) => (
              <div className='plan-feature' key={idx}>
                {this.renderLink(feature)}
              </div>
            ))
          }
        </div>
        
        <div className='plan-footer'>
          <button 
            className={`subscription-plan ${buttonClass}`}
            onClick={action}
          >
            {buttonText}
          </button>
        </div>
      </div>
    )
  }

}